import { TRANSACTION_ADDED, TRANSACTION_DELETED, TRANSACTION_EDITED, TRANSACTION_SET } from 'src/app/redux/redux-types';
import { reduxTransactionTypes } from 'src/types';

export const transactionDefaultState: reduxTransactionTypes.TransactionType = {
  transactionList: [],
};

export const transactionReducer = (
  state = transactionDefaultState,
  action: reduxTransactionTypes.ActionType,
): reduxTransactionTypes.TransactionType => {
  switch (action.type) {
    case TRANSACTION_SET:
      return {
        ...state,
        transactionList: action.payload,
      };
    case TRANSACTION_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.transactionList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        transactionList: [...state.transactionList, action.payload],
      };
    case TRANSACTION_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.transactionList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        transactionList: [
          ...state.transactionList.slice(0, updateIndex),
          action.payload,
          ...state.transactionList.slice(updateIndex + 1),
        ],
      };
    case TRANSACTION_DELETED:
      return {
        ...state,
        transactionList: state.transactionList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
